module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "bg_f5f6f9"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('dl', {
    staticClass: "step-list"
  }, [_c('dt', {
    staticClass: "wifi-tips"
  }, [_c('h4', {
    staticClass: "step-list-header"
  }, [_vm._v("第一步")]), _vm._v(" "), _c('div', {
    staticClass: "step-list-img"
  }, [_c('img-base64', {
    attrs: {
      "name": "network_set"
    }
  }), _vm._v(" "), _c('img-base64', {
    attrs: {
      "name": "imgBase64"
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('dd', [_c('img-base64', {
    attrs: {
      "name": "phone_wifi"
    }
  })], 1), _vm._v(" "), _c('dt', [_c('h4', {
    staticClass: "step-list-header"
  }, [_vm._v("第二步")]), _vm._v(" "), _c('div', {
    staticClass: "step-list-img"
  }, [_c('img-base64', {
    attrs: {
      "name": "tmall"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "step-list-content"
  }, [_c('h5', [_vm._v("回到 天猫精灵")]), _vm._v(" "), _c('span', [_vm._v("继续下一步配置操作")]), _vm._v(" "), _c('button', {
    staticClass: "btn-next btn-click-bg-change",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextBtnClick
    }
  }, [_vm._v("下一步\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-list-content"
  }, [_c('h5', [_vm._v("进入设置")]), _vm._v(" "), _c('span', [_vm._v("进入手机设置，选择“无线局域网”选择开头“HomeMate”的设备WiFi")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-187acb64"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/connect/wifi/TipsOfConnect.vue
// module id = 869
// module chunks = 1